// Utility functions for device detection and app store redirection

export const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // Desktop/Other
  return 'desktop';
};

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/weartwice/id6733228175';
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.weartwice.weartwice';

export const handleDownloadClick = (e) => {
  const device = detectDevice();

  if (device === 'ios') {
    e.preventDefault();
    window.location.href = IOS_APP_STORE_URL;
    return false;
  } else if (device === 'android') {
    e.preventDefault();
    window.location.href = ANDROID_PLAY_STORE_URL;
    return false;
  }

  // For desktop, let the default Link behavior handle navigation to /qr-code
  return true;
};

export const handleViewInApp = (e, productId) => {
  const device = detectDevice();

  if (device !== 'ios' && device !== 'android') {
    // For desktop, let the default Link behavior handle navigation to /qr-code
    return true;
  }

  e.preventDefault();

  const storeUrl = device === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL;
  const deepLink = `weartwice://product/${productId}`;

  // Try to open the app; fall back to the store if it's not installed
  const fallbackTimer = setTimeout(() => {
    window.location.href = storeUrl;
  }, 1500);

  window.addEventListener('blur', () => clearTimeout(fallbackTimer), { once: true });

  window.location.href = deepLink;

  return false;
};
